/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v1
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorResponse } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { PagePlatformControlDetailed } from '../model';
// @ts-ignore
import type { PagePlatformFrameworkVersionOverview } from '../model';
// @ts-ignore
import type { PagePlatformRequirementDetailed } from '../model';
// @ts-ignore
import type { PlatformFrameworkVersionOverview } from '../model';
/**
 * FrameworksApi - axios parameter creator
 */
export const FrameworksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Framework In Organization
         * @param {string} frameworkCode 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGet: async (frameworkCode: string, organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'frameworkCode' is not null or undefined
            assertParamExists('getFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGet', 'frameworkCode', frameworkCode)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGet', 'organizationId', organizationId)
            const localVarPath = `/v1/organizations/{organization_id}/frameworks/{framework_code}`
                .replace('{framework_code}', encodeURIComponent(String(frameworkCode)))
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Framework Version In Organization
         * @param {string} frameworkCode 
         * @param {string} version 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGet: async (frameworkCode: string, version: string, organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'frameworkCode' is not null or undefined
            assertParamExists('getFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGet', 'frameworkCode', frameworkCode)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('getFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGet', 'version', version)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGet', 'organizationId', organizationId)
            const localVarPath = `/v1/organizations/{organization_id}/frameworks/{framework_code}/versions/{version}`
                .replace('{framework_code}', encodeURIComponent(String(frameworkCode)))
                .replace('{version}', encodeURIComponent(String(version)))
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Framework Versions In Organization
         * @param {string} frameworkCode 
         * @param {string} organizationId 
         * @param {string | null} [name] The name filter.
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGet: async (frameworkCode: string, organizationId: string, name?: string | null, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'frameworkCode' is not null or undefined
            assertParamExists('getFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGet', 'frameworkCode', frameworkCode)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGet', 'organizationId', organizationId)
            const localVarPath = `/v1/organizations/{organization_id}/frameworks/{framework_code}/versions`
                .replace('{framework_code}', encodeURIComponent(String(frameworkCode)))
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all platform framework controls.  Args:     db (Session): The database session.  Returns:     Page[schemas.PlatformControlDetailed]: The requirements.
         * @summary Get Platform Framework Controls
         * @param {string} frameworkCode 
         * @param {string} organizationId 
         * @param {string | null} [name] The name filter.
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGet: async (frameworkCode: string, organizationId: string, name?: string | null, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'frameworkCode' is not null or undefined
            assertParamExists('getPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGet', 'frameworkCode', frameworkCode)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGet', 'organizationId', organizationId)
            const localVarPath = `/v1/organizations/{organization_id}/frameworks/{framework_code}/controls`
                .replace('{framework_code}', encodeURIComponent(String(frameworkCode)))
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all platform framework requirements.  Args:     db (Session): The database session.  Returns:     Page[schemas.PlatformRequirementDetailed]: The requirements.
         * @summary Get Platform Framework Requirements
         * @param {string} frameworkCode 
         * @param {string} organizationId 
         * @param {string | null} [name] The name filter.
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGet: async (frameworkCode: string, organizationId: string, name?: string | null, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'frameworkCode' is not null or undefined
            assertParamExists('getPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGet', 'frameworkCode', frameworkCode)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGet', 'organizationId', organizationId)
            const localVarPath = `/v1/organizations/{organization_id}/frameworks/{framework_code}/requirements`
                .replace('{framework_code}', encodeURIComponent(String(frameworkCode)))
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FrameworksApi - functional programming interface
 */
export const FrameworksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FrameworksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Framework In Organization
         * @param {string} frameworkCode 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGet(frameworkCode: string, organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlatformFrameworkVersionOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGet(frameworkCode, organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FrameworksApi.getFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Framework Version In Organization
         * @param {string} frameworkCode 
         * @param {string} version 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGet(frameworkCode: string, version: string, organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlatformFrameworkVersionOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGet(frameworkCode, version, organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FrameworksApi.getFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Framework Versions In Organization
         * @param {string} frameworkCode 
         * @param {string} organizationId 
         * @param {string | null} [name] The name filter.
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGet(frameworkCode: string, organizationId: string, name?: string | null, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagePlatformFrameworkVersionOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGet(frameworkCode, organizationId, name, sortBy, descending, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FrameworksApi.getFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all platform framework controls.  Args:     db (Session): The database session.  Returns:     Page[schemas.PlatformControlDetailed]: The requirements.
         * @summary Get Platform Framework Controls
         * @param {string} frameworkCode 
         * @param {string} organizationId 
         * @param {string | null} [name] The name filter.
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGet(frameworkCode: string, organizationId: string, name?: string | null, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagePlatformControlDetailed>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGet(frameworkCode, organizationId, name, sortBy, descending, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FrameworksApi.getPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all platform framework requirements.  Args:     db (Session): The database session.  Returns:     Page[schemas.PlatformRequirementDetailed]: The requirements.
         * @summary Get Platform Framework Requirements
         * @param {string} frameworkCode 
         * @param {string} organizationId 
         * @param {string | null} [name] The name filter.
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGet(frameworkCode: string, organizationId: string, name?: string | null, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagePlatformRequirementDetailed>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGet(frameworkCode, organizationId, name, sortBy, descending, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FrameworksApi.getPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FrameworksApi - factory interface
 */
export const FrameworksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FrameworksApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Framework In Organization
         * @param {FrameworksApiGetFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGet(requestParameters: FrameworksApiGetFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PlatformFrameworkVersionOverview> {
            return localVarFp.getFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGet(requestParameters.frameworkCode, requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Framework Version In Organization
         * @param {FrameworksApiGetFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGet(requestParameters: FrameworksApiGetFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PlatformFrameworkVersionOverview> {
            return localVarFp.getFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGet(requestParameters.frameworkCode, requestParameters.version, requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Framework Versions In Organization
         * @param {FrameworksApiGetFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGet(requestParameters: FrameworksApiGetFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagePlatformFrameworkVersionOverview> {
            return localVarFp.getFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGet(requestParameters.frameworkCode, requestParameters.organizationId, requestParameters.name, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all platform framework controls.  Args:     db (Session): The database session.  Returns:     Page[schemas.PlatformControlDetailed]: The requirements.
         * @summary Get Platform Framework Controls
         * @param {FrameworksApiGetPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGet(requestParameters: FrameworksApiGetPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagePlatformControlDetailed> {
            return localVarFp.getPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGet(requestParameters.frameworkCode, requestParameters.organizationId, requestParameters.name, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all platform framework requirements.  Args:     db (Session): The database session.  Returns:     Page[schemas.PlatformRequirementDetailed]: The requirements.
         * @summary Get Platform Framework Requirements
         * @param {FrameworksApiGetPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGet(requestParameters: FrameworksApiGetPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagePlatformRequirementDetailed> {
            return localVarFp.getPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGet(requestParameters.frameworkCode, requestParameters.organizationId, requestParameters.name, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGet operation in FrameworksApi.
 */
export interface FrameworksApiGetFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGetRequest {
    readonly frameworkCode: string

    readonly organizationId: string
}

/**
 * Request parameters for getFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGet operation in FrameworksApi.
 */
export interface FrameworksApiGetFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGetRequest {
    readonly frameworkCode: string

    readonly version: string

    readonly organizationId: string
}

/**
 * Request parameters for getFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGet operation in FrameworksApi.
 */
export interface FrameworksApiGetFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGetRequest {
    readonly frameworkCode: string

    readonly organizationId: string

    /**
     * The name filter.
     */
    readonly name?: string | null

    /**
     * Sort by a field.
     */
    readonly sortBy?: string | null

    /**
     * Sort order. If true, descending, otherwise ascending.
     */
    readonly descending?: boolean

    readonly page?: number

    readonly size?: number
}

/**
 * Request parameters for getPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGet operation in FrameworksApi.
 */
export interface FrameworksApiGetPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGetRequest {
    readonly frameworkCode: string

    readonly organizationId: string

    /**
     * The name filter.
     */
    readonly name?: string | null

    /**
     * Sort by a field.
     */
    readonly sortBy?: string | null

    /**
     * Sort order. If true, descending, otherwise ascending.
     */
    readonly descending?: boolean

    readonly page?: number

    readonly size?: number
}

/**
 * Request parameters for getPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGet operation in FrameworksApi.
 */
export interface FrameworksApiGetPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGetRequest {
    readonly frameworkCode: string

    readonly organizationId: string

    /**
     * The name filter.
     */
    readonly name?: string | null

    /**
     * Sort by a field.
     */
    readonly sortBy?: string | null

    /**
     * Sort order. If true, descending, otherwise ascending.
     */
    readonly descending?: boolean

    readonly page?: number

    readonly size?: number
}

/**
 * FrameworksApi - object-oriented interface
 */
export class FrameworksApi extends BaseAPI {
    /**
     * 
     * @summary Get Framework In Organization
     * @param {FrameworksApiGetFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGet(requestParameters: FrameworksApiGetFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGetRequest, options?: RawAxiosRequestConfig) {
        return FrameworksApiFp(this.configuration).getFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGet(requestParameters.frameworkCode, requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Framework Version In Organization
     * @param {FrameworksApiGetFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGet(requestParameters: FrameworksApiGetFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGetRequest, options?: RawAxiosRequestConfig) {
        return FrameworksApiFp(this.configuration).getFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGet(requestParameters.frameworkCode, requestParameters.version, requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Framework Versions In Organization
     * @param {FrameworksApiGetFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGet(requestParameters: FrameworksApiGetFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGetRequest, options?: RawAxiosRequestConfig) {
        return FrameworksApiFp(this.configuration).getFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGet(requestParameters.frameworkCode, requestParameters.organizationId, requestParameters.name, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all platform framework controls.  Args:     db (Session): The database session.  Returns:     Page[schemas.PlatformControlDetailed]: The requirements.
     * @summary Get Platform Framework Controls
     * @param {FrameworksApiGetPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGet(requestParameters: FrameworksApiGetPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGetRequest, options?: RawAxiosRequestConfig) {
        return FrameworksApiFp(this.configuration).getPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGet(requestParameters.frameworkCode, requestParameters.organizationId, requestParameters.name, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all platform framework requirements.  Args:     db (Session): The database session.  Returns:     Page[schemas.PlatformRequirementDetailed]: The requirements.
     * @summary Get Platform Framework Requirements
     * @param {FrameworksApiGetPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGet(requestParameters: FrameworksApiGetPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGetRequest, options?: RawAxiosRequestConfig) {
        return FrameworksApiFp(this.configuration).getPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGet(requestParameters.frameworkCode, requestParameters.organizationId, requestParameters.name, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }
}

